exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-list-item>h3 {\n  word-break: break-all;\n}\n\n", ""]);

// exports
